/**
 * Module dependencies.
 */

import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import React, { ForwardedRef, forwardRef } from 'react';
import moment from 'moment';
import { TimePicker, TimePickerProps } from './time-picker';

/**
 * `Props` type.
 */

type Props<T extends FieldValues> = UseControllerProps<T> &
  TimePickerProps & {
    normalizeValue?: (newValue: string, value: string) => string;
  };

/**
 * `TimePickerComponent` component.
 */

export function TimePickerComponent<T extends FieldValues>(
  props: Props<T>,
  forwardedRef: ForwardedRef<any>
): JSX.Element {
  const { control, defaultValue, name, normalizeValue, rules, shouldUnregister, ...inputProps } = props;

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { name, onBlur, onChange, value }, fieldState: { error, invalid, isDirty, isTouched } }) => {
        return (
          <TimePicker
            invalid={invalid}
            isDirty={isDirty}
            isTouched={isTouched}
            name={name}
            onBlur={onBlur as any}
            value={value ? moment(value) : null}
            {...inputProps}
            error={error}
            onChange={newValue => {
              const finalValue = normalizeValue ? normalizeValue(String(newValue), value) : newValue;

              onChange(finalValue);
            }}
            ref={forwardedRef}
          />
        );
      }}
      rules={rules}
      shouldUnregister={shouldUnregister}
    />
  );
}

/**
 * Export `TimePickerField`.
 */

export const TimePickerField = forwardRef<Props<any>, any>(TimePickerComponent);
